import AppConstant from '../../../config/app.constants';

class ServiceSettingsAllController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, Modal, ActionCodeService, ServiceActionPrioritiesService, LocationService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.ActionCodeService = ActionCodeService;
        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.LocationService = LocationService;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            actionCodes: [],
            searchText: '',
            loading: true,
            actionCodeResponse: [],
            actionCodeData: {},
            _loading: false
        }
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.actionCodeObj = {};
        this.responseCodes = {};
        this.rootCauseCodes = {};
        this.errorMessage = '';
        this.thresholdList = ['redThreshold', 'orangeThreshold', 'yellowThreshold', 'otherThreshold'];
        this.isDuplicate = false;
        this.categoryList = [
            { label: 'FLM', value: 'FLM' },
            { label: 'SLM', value: 'SLM' }
        ]
        this.pmSchedulesList = [];
    }

    $onInit() {
        // console.log("call");
        this.loadData();
        this.loadPriorities();
        this.loadPM();
    }

    loadPM() {
        this.loadPreventativeMaintenances('', 0);
    }

    loadPreventativeMaintenances(searchKey, offset) {
        searchKey = searchKey || '';
        return this.LocationService.getPreventativeMaintenanceList(10, offset, searchKey)
            .then((data) => {
                const pmList = (data.results || []).map(pm => ({
                    Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
                    Value: pm.id,
                    isSuspended: pm.status === 'Suspended'
                }));
                if (offset === 0 || offset === undefined) {
                    this.totalPMRecords = data.total || 0;
                    this.pmSearchList = pmList;
                } else {
                    this.pmSearchList = this.pmSearchList.concat(pmList);
                }
            })
            .catch(err => console.error(err));
    }

    isPMSuspended(val) {
        if (!val) return false;
        if (val && typeof val === 'object' && val.isSuspended !== undefined) {
            return val.isSuspended;
        }
        const id = (val && typeof val === 'object') ? val.Value : val;
        const pm = (this.pmSearchList || []).find(p => p.Value === id);
        return pm && pm.isSuspended;
    }

    loadPriorities() {
        this.ServiceActionPrioritiesService.all('', 0, 1000)
            .then(data => {
                this.prioritiesList = data.results.filter(p => p.active);
            })
            .catch(err => console.error(err));
    }

    createActionCodeModal() {
        this.Modal.createActionCode(this.prioritiesList, this.pmSchedulesList, ({ modal, actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes,
            rootCauses, redThreshold, orangeThreshold, yellowThreshold, otherThreshold, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId }) => {

            this.ActionCodeService.createServiceOrderActionCodes(actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes, rootCauses,
                redThreshold, orangeThreshold, yellowThreshold, otherThreshold, this.model.currentBranch, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId)
                .then(() => {
                    setTimeout(() => {
                        this.loadData();
                    });
                    modal.close();
                })
                .catch((err) => {
                    this.Modal.errorModal(err.data.message)
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    createActionCode(actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId) {
        return this.ActionCodeService.create({
            label: actionCodeLabel,
            code: actionCode,
            minResponseSelect: minResponse,
            maxResponseSelect: maxResponse,
            minRootCauseSelect: minRootCause,
            maxRootCauseSelect: maxRootCause,
            thresholds, partsCapture, requirePicture, openRequired,
            category, serviceType, expectedCompletionTime: expectedCompletionTime === '' ? null : expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId
        }, this.model.currentBranch)
            .then(() => { })
            .catch((err) => {
                this.errorMessage = '';
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
                this.Modal.errorModal(this.errorMessage)
            })
    }

    generateSearchObj() {
        return {
            queryText: '%' + this.model.searchText + '%',
            isQuery: false
        }
    }

    loadData() {
        this.model.loading = true;
        this.ActionCodeService.all(this.generateSearchObj(), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.pagination.total = data.total;
                this.model.actionCodes = data.results;
            })
            .catch((err) => {
                this.error = err.message;
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    pageChange() {
        this.loadData();
    }

    getActionCodeResponse(data) {
        this.actionCodeObj[data.id] = { process: true };

        if (data.panelExpanded) {
            this.ActionCodeService.getActionCodes(data.id)
                .then((actionCodeInfo) => {
                    this.model.actionCodeData[data.id] = { details: actionCodeInfo.results };
                    
                    const pmId = actionCodeInfo.results.preventativeMaintenanceId;
                    if (pmId) {
                        this.LocationService.getPreventativeMaintenance(pmId)
                            .then(pm => {
                                this.model.actionCodeData[data.id].details.preventativeMaintenanceId = {
                                    Key: pm.title + (pm.status === 'Suspended' || pm.status === false ? ' (suspended)' : ''),
                                    Value: pm.id,
                                    isSuspended: pm.status === 'Suspended' || pm.status === false
                                };
                            })
                            .catch(err => console.error(err));
                    } else {
                        this.model.actionCodeData[data.id].details.preventativeMaintenanceId = null;
                    }
                    
                    this.model.actionCodeData[data.id].details.redThreshold = this.model.actionCodeData[data.id].details.redThreshold ? this.getTime(this.model.actionCodeData[data.id].details.redThreshold) : null;
                    this.model.actionCodeData[data.id].details.orangeThreshold = this.model.actionCodeData[data.id].details.orangeThreshold ? this.getTime(this.model.actionCodeData[data.id].details.orangeThreshold) : null;
                    this.model.actionCodeData[data.id].details.yellowThreshold = this.model.actionCodeData[data.id].details.yellowThreshold ? this.getTime(this.model.actionCodeData[data.id].details.yellowThreshold) : null;
                    this.model.actionCodeData[data.id].details.otherThreshold = this.model.actionCodeData[data.id].details.otherThreshold ? this.getTime(this.model.actionCodeData[data.id].details.otherThreshold) : null;
                    this.model.actionCodeData[data.id].details.expectedCompletionTime = this.model.actionCodeData[data.id].details.expectedCompletionTime ? this.getTime(this.model.actionCodeData[data.id].details.expectedCompletionTime) : null;
                    
                    if (this.model.actionCodeData[data.id].details.serviceActionPriorityId) {
                        const exists = this.prioritiesList.find(p => p.id === this.model.actionCodeData[data.id].details.serviceActionPriorityId);
                        if (!exists) {
                            this.model.actionCodeData[data.id].details.serviceActionPriorityId = null;
                        }
                    }

                    this.responseCodes[data.id] = JSON.parse(JSON.stringify(actionCodeInfo.results.responses));
                    this.rootCauseCodes[data.id] = JSON.parse(JSON.stringify(actionCodeInfo.results.rootCauses));
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.actionCodeObj[data.id].process = false;
                })
        }
    }

    addNewServiceResponse(index) {
        this.model.actionCodeData[index].details.responses.push({
            id: '',
            label: '',
            sortOrder: this.model.actionCodeData[index].details.responses.length + 1,
        });
    }

    addNewRootCause(index) {
        this.model.actionCodeData[index].details.rootCauses.push({
            id: "",
            label: "",
            sortOrder: this.model.actionCodeData[index].details.rootCauses.length + 1,
        });
    }

    removeServiceResponse(actionId, index) {
        if (this.model.actionCodeData[actionId].details.responses[index].id) {
            if (this.model.actionCodeData[actionId].details.itemRemove && Array.isArray(this.model.actionCodeData[actionId].details.itemRemove)) {
                this.model.actionCodeData[actionId].details.itemRemove.push(this.model.actionCodeData[actionId].details.responses[index])
            } else {
                this.model.actionCodeData[actionId].details.itemRemove = [this.model.actionCodeData[actionId].details.responses[index]]
            }

            this.model.actionCodeData[actionId].details.responses.splice(index, 1);
        } else {
            this.model.actionCodeData[actionId].details.responses.splice(index, 1);
        }
    }

    removeRootCause(actionId, index) {
        if (this.model.actionCodeData[actionId].details.rootCauses[index].id) {
            if (this.model.actionCodeData[actionId].details.rootCauseRemove && Array.isArray(this.model.actionCodeData[actionId].details.rootCauseRemove)) {
                this.model.actionCodeData[actionId].details.rootCauseRemove.push(this.model.actionCodeData[actionId].details.rootCauses[index]);
            } else {
                this.model.actionCodeData[actionId].details.rootCauseRemove = [this.model.actionCodeData[actionId].details.rootCauses[index]];
            }

            this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
        } else {
            this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
        }
    }

    removeRootCause(actionId, index) {
        if (this.model.actionCodeData[actionId].details.rootCauses[index].id) {
            if (this.model.actionCodeData[actionId].details.rootCauseRemove && Array.isArray(this.model.actionCodeData[actionId].details.rootCauseRemove)) {
                this.model.actionCodeData[actionId].details.rootCauseRemove.push(this.model.actionCodeData[actionId].details.rootCauses[index]);
            } else {
                this.model.actionCodeData[actionId].details.rootCauseRemove = [this.model.actionCodeData[actionId].details.rootCauses[index]];
            }

            this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
        } else {
            this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
        }
    }
    disableCodeUpdate(actionId) {
        if (!actionId || !this.model.actionCodeData || !this.model.actionCodeData[actionId]) return true;
        let isEmpty = this.model.actionCodeData[actionId].details.responses && this.model.actionCodeData[actionId].details.responses.length ? this.model.actionCodeData[actionId].details.responses.filter(item => !item.label) : false;
        let isRootCauseEmpty = this.model.actionCodeData[actionId].details.rootCauses && this.model.actionCodeData[actionId].details.rootCauses.length ? this.model.actionCodeData[actionId].details.rootCauses.filter(item => !item.label) : false;
        let thresholds = this.thresholdList.map((d) => {
            return this.model.actionCodeData[actionId].details[d] ? moment(this.model.actionCodeData[actionId].details[d]).format('HH:mm:00') : null
        })
        let duplicate = thresholds.reduce((acc, currentValue, index, array) => {
            if (currentValue) if (array.indexOf(currentValue) != index && !acc.includes(currentValue)) acc.push(currentValue);
            return acc;
        }, []);
        this.isDuplicate = this.model.actionCodeData[actionId].details.thresholds && duplicate.length;
        return (isEmpty.length || isRootCauseEmpty.length || this.isDuplicate) ? true : false;
    }

    comparerArrayDiff(otherArray) {
        return function (current) {
            return otherArray.filter(function (other) {
                return other.label == current.label && other.sortOrder == current.sortOrder && other.category == current.category
            }).length == 0;
        }
    }

    compareRootCauseArrayDiff(otherArray) {
        return function (current) {
            return (
                otherArray.filter(function (other) {
                    return other.label == current.label && other.sortOrder == current.sortOrder;
                }).length == 0
            );
        };
    }

    updateServiceItem(index) {
        if (!this.hasACL['edit']) return;

        this.model.loading = true;
        let data = JSON.parse(JSON.stringify(this.model.actionCodeData[index].details));
        data['responses'] = data.responses.filter(this.comparerArrayDiff(this.responseCodes[index]));
        data["rootCauses"] = data.rootCauses.filter(this.compareRootCauseArrayDiff(this.rootCauseCodes[index]));
        data['redThreshold'] = data['redThreshold'] ? moment(data['redThreshold']).format('HH:mm:00') : null;
        data['orangeThreshold'] = data['orangeThreshold'] ? moment(data['orangeThreshold']).format('HH:mm:00') : null;
        data['yellowThreshold'] = data['yellowThreshold'] ? moment(data['yellowThreshold']).format('HH:mm:00') : null;
        data['otherThreshold'] = data['otherThreshold'] ? moment(data['otherThreshold']).format('HH:mm:00') : null;
        data['expectedCompletionTime'] = data['expectedCompletionTime'] ? moment(data['expectedCompletionTime']).format('HH:mm:00') : null;
        data['preventativeMaintenanceId'] = data['preventativeMaintenanceId'] ? data['preventativeMaintenanceId'].Value : null;

        this.ActionCodeService.updateCodeResponse(data)
            .then(res => {
                if (res.success) {
                    if (res.actionResponses && res.actionResponses.length) {
                        this.model.actionCodeData[index].details.responses = res.actionResponses;
                        this.model.actionCodeData[index].details.rootCauses = res.actionRootCauses;
                    }

                    const actionCode = this.model.actionCodes.find(item => item.id === index);
                    if (actionCode) {
                        actionCode.label = data.label;
                    }
                    this.model.actionCodeData[index].details.itemRemove = [];
                    this.model.actionCodeData[index].details.rootCauseRemove = [];
                }
            })
            .catch(err => {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
                this.Modal.errorModal(this.errorMessage);
            }).finally(() => {
                this.model.loading = false;
            })
    }

    getTime(time) {
        if (!time) {
            return time;
        }

        time = time.split(':');

        let d = new Date();

        d.setHours(+time[0]);
        d.setMinutes(time[1]);
        d.setSeconds(0);
        d.setMilliseconds(0);

        return d;
    }
}

export default ServiceSettingsAllController;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/all/service_settings.all.controller.js